import * as A from 'astronomy-engine';
import { Mat3, Vec3, mat3Apply, mat3T } from '../lib/math';

export interface Place {
  lat: number;
  lon: number;
  height: number; // metres
  name: string;
  timeZone?: string;
}

/** Rotation from J2000 equatorial to local East-North-Up for an instant and place. */
export function eqjToEnuMatrix(date: Date, place: Place): Mat3 {
  const obs = new A.Observer(place.lat, place.lon, place.height);
  const r = A.Rotation_EQJ_HOR(date, obs).rot; // AE layout: M[row][col] = rot[col][row]; HOR = (north, west, zenith)
  const M = (row: number, col: number) => r[col][row];
  return Float64Array.of(
    -M(1, 0), -M(1, 1), -M(1, 2), // east = −west
    M(0, 0), M(0, 1), M(0, 2), // north
    M(2, 0), M(2, 1), M(2, 2), // zenith
  );
}

export class SkyFrame {
  eqjToEnu: Mat3 = new Float64Array(9);
  enuToEqj: Mat3 = new Float64Array(9);
  date = new Date();
  observer = new A.Observer(51.5, -0.12, 20);

  update(date: Date, place: Place) {
    this.date = date;
    this.observer = new A.Observer(place.lat, place.lon, place.height);
    this.eqjToEnu = eqjToEnuMatrix(date, place);
    this.enuToEqj = mat3T(this.eqjToEnu);
  }

  toEnu(eqj: Vec3, out?: Vec3): Vec3 {
    return mat3Apply(this.eqjToEnu, eqj[0], eqj[1], eqj[2], out);
  }

  toEqj(enu: Vec3, out?: Vec3): Vec3 {
    return mat3Apply(this.enuToEqj, enu[0], enu[1], enu[2], out);
  }
}
